/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import { retrieveSourcesFailure, retrieveSourcesSuccess } from '@store/scenario/sources/sources-slice';
import { Source } from '@scenario/models/source.model';

export const retrieveSourcesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('sources/retrieveSources'),
    concatMap((_action: Action) =>
      from(dependencies.sourceGateway.retrieveAll()).pipe(
        map((sources: Source[]) => retrieveSourcesSuccess(sources)),
        catchError(() => of(retrieveSourcesFailure('Fail to retrieve sources'))),
      ),
    ),
  );
